import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
} from './actions';

const initialState = {
  otpSent: false,
};

export default function forgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return { ...state, otpSent: false };
    case FORGOT_PASSWORD_SUCCESS:
      return { ...state, otpSent: true };
    case FORGOT_PASSWORD_FAILURE:
      return { ...state, otpSent: false };
    default:
      return state;
  }
}
